import { put, select, takeLatest } from 'redux-saga/effects'
import { setPCRCrew } from '../store/crew.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getCrewListSelector } from '../selectors'
import { CrewConstants } from '../store/crew.constants'
import { IPCRCrewMemberList, ICrewMember, ICrewMemberList } from '../store/crew.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getPCRCrewList() {
  try {
    const crewList: ICrewMemberList = yield select(getCrewListSelector)
    const pcrCrew: IPCRCrewMemberList = []
    crewList.map((crewMember: ICrewMember, index) =>
      pcrCrew.push({
        crewId: index + 1,
        user: crewMember.userId,
        roles: crewMember.roleId,
        rolesPNNV: crewMember.roleIdPNNV,
        licensures: crewMember.licensures,
        preceptorStudent: crewMember.preceptorStudent,
      })
    )
    yield put(setPCRCrew(pcrCrew))
  } catch (e) {
    yield put(throwPcrException(`getCrewList() error: ${e}`))
  }
}

export function* getPCRCrewSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS, CrewConstants.SET_CREW_LIST], getPCRCrewList)
}
